import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-957ba7e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-hunts-admin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "nge-hunts-head" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Hunts"),
  /*#__PURE__*/_createElementVNode("p", { class: "nge-hunts-lead" }, "A timed hunt for mergers and missing extensions: players Ctrl + Click to drop gems, each judged as it lands, until they find them all or run out of gems. Gold, silver and bronze go to the best hunters when it ends.")
], -1 /* HOISTED */))
const _hoisted_3 = {
  key: 0,
  class: "nge-hunts-warn"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "supabase-hunts.sql", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "ewHunt", -1 /* HOISTED */))
const _hoisted_6 = {
  key: 2,
  ref: "msgEl",
  class: "nge-hunts-msg",
  role: "status"
}
const _hoisted_7 = {
  key: 0,
  class: "nge-hunts-msg-times"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Announced", -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Starts", -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Ends", -1 /* HOISTED */))
const _hoisted_12 = {
  key: 0,
  class: "nge-hunts-muted"
}
const _hoisted_13 = {
  key: 1,
  class: "nge-hunts-muted"
}
const _hoisted_14 = { class: "nge-hunts-list" }
const _hoisted_15 = ["onClick", "onKeydown"]
const _hoisted_16 = { class: "nge-hunts-name" }
const _hoisted_17 = {
  key: 0,
  class: "nge-hunts-chip nge-hunts-chip--admins"
}
const _hoisted_18 = { class: "nge-hunts-meta" }
const _hoisted_19 = { class: "nge-hunts-title-row" }
const _hoisted_20 = {
  class: "nge-hunts-title-edit",
  title: "Click to change the title"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  width: "13",
  height: "13",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.2 2.3l2.5 2.5-7.9 7.9-3.1.6.6-3.1z",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.3",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-hunts-help" }, [
  /*#__PURE__*/_createTextVNode("Hunters say these are real problems the answers missed, the oldest first. "),
  /*#__PURE__*/_createElementVNode("b", null, "Go through them"),
  /*#__PURE__*/_createTextVNode(" opens them one by one on the view, with the answers drawn in, a note for each, and who sent each spot first. Or here: "),
  /*#__PURE__*/_createElementVNode("b", null, "Add to the answers"),
  /*#__PURE__*/_createTextVNode(" (or "),
  /*#__PURE__*/_createElementVNode("b", null, "Count it"),
  /*#__PURE__*/_createTextVNode(", for a gem) puts it in the key, judges everyone again and gives Laser Eyes; "),
  /*#__PURE__*/_createElementVNode("b", null, "Dismiss"),
  /*#__PURE__*/_createTextVNode(" takes it off this list.")
], -1 /* HOISTED */))
const _hoisted_24 = { class: "nge-hunts-gems" }
const _hoisted_25 = { class: "nge-hunts-muted" }
const _hoisted_26 = {
  key: 0,
  class: "nge-hunts-report-note"
}
const _hoisted_27 = ["disabled", "onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "1. The answer key", -1 /* HOISTED */))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-hunts-help" }, [
  /*#__PURE__*/_createTextVNode("Paste a share link of the cell with each place marked by a point: mergers (to cut) in one annotation layer, extensions (to merge) in another. Open it and check the ticks and kinds: the key is read from the screen by itself, again whenever they change. Players start from the same view with every annotation layer taken out, and drop one gem on each merger or extension they find. Branches that run out of the data are no missing extensions: mark those ends in a layer named "),
  /*#__PURE__*/_createElementVNode("b", null, "edge"),
  /*#__PURE__*/_createTextVNode(" (it is picked up as edges by itself; the volume's own edges count without marking, and players see the cells glow teal there), and an Extend gem there is answered \"Edge of the dataset\", with no gem used.")
], -1 /* HOISTED */))
const _hoisted_34 = { class: "nge-hunts-row" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  class: "nge-hunts-keylayers",
  "aria-label": "Layers with the places marked"
}
const _hoisted_37 = {
  key: 0,
  class: "nge-hunts-muted"
}
const _hoisted_38 = { class: "nge-hunts-keylayer-name" }
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = { class: "nge-hunts-muted" }
const _hoisted_41 = ["onUpdate:modelValue", "aria-label", "disabled"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "cut" }, "mergers (to cut)", -1 /* HOISTED */))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "merge" }, "extensions (to merge)", -1 /* HOISTED */))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "edge" }, "edge (of the dataset, not a problem)", -1 /* HOISTED */))
const _hoisted_45 = [
  _hoisted_42,
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = { class: "nge-hunts-row" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  key: 0,
  class: "nge-hunts-warnline"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Open the link", -1 /* HOISTED */))
const _hoisted_50 = {
  key: 1,
  class: "nge-hunts-help"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Open the link", -1 /* HOISTED */))
const _hoisted_52 = {
  key: 2,
  class: "nge-hunts-muted"
}
const _hoisted_53 = {
  key: 3,
  class: "nge-hunts-cells"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-hunts-help" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Where players start."),
  /*#__PURE__*/_createTextVNode(" A link is often centered on a merger, which would give it away. Move the crosshair to where players should start (the soma is a good place) and press "),
  /*#__PURE__*/_createElementVNode("b", null, "Use the crosshair"),
  /*#__PURE__*/_createTextVNode(", or paste x, y, z as the coordinate bar shows them.")
], -1 /* HOISTED */))
const _hoisted_55 = { class: "nge-hunts-cellrow nge-hunts-startrow" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hunts-cellid" }, "Start", -1 /* HOISTED */))
const _hoisted_57 = ["onUpdate:modelValue", "placeholder", "aria-label"]
const _hoisted_58 = {
  key: 4,
  class: "nge-hunts-warnline"
}
const _hoisted_59 = {
  key: 5,
  class: "nge-hunts-warnline"
}
const _hoisted_60 = ["disabled"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "2. The words", -1 /* HOISTED */))
const _hoisted_62 = { class: "nge-hunts-desc-head" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hunts-desc-label" }, "Description", -1 /* HOISTED */))
const _hoisted_64 = {
  class: "nge-hunts-fmt",
  role: "toolbar",
  "aria-label": "Format"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "B", -1 /* HOISTED */))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = {
  key: 0,
  class: "nge-hunts-desc-preview"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hunts-muted" }, "What players see:", -1 /* HOISTED */))
const _hoisted_69 = ["innerHTML"]
const _hoisted_70 = ["disabled"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "3. When", -1 /* HOISTED */))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-hunts-help" }, "Eastern time (ET). Players see each time in their own time zone, named.", -1 /* HOISTED */))
const _hoisted_73 = { class: "nge-hunts-check" }
const _hoisted_74 = ["checked", "disabled"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Only admins"),
  /*#__PURE__*/_createTextVNode(": players never see it, and nothing posts in chat.")
], -1 /* HOISTED */))
const _hoisted_76 = {
  key: 0,
  class: "nge-hunts-warnline"
}
const _hoisted_77 = { class: "nge-hunts-grid" }
const _hoisted_78 = { class: "nge-hunts-timehead" }
const _hoisted_79 = { class: "nge-hunts-when" }
const _hoisted_80 = { class: "nge-hunts-timehead" }
const _hoisted_81 = { class: "nge-hunts-when" }
const _hoisted_82 = { class: "nge-hunts-when" }
const _hoisted_83 = { class: "nge-hunts-check nge-hunts-answers" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Show the answers after the end"),
  /*#__PURE__*/_createTextVNode(": players can ring every merger and extension. Untick it to use these cells in another Hunt.")
], -1 /* HOISTED */))
const _hoisted_85 = { class: "nge-hunts-resultshours" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hunts-muted" }, "(24 if empty; at most a week)", -1 /* HOISTED */))
const _hoisted_87 = ["disabled"]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "4. Scoring and prizes", -1 /* HOISTED */))
const _hoisted_89 = { class: "nge-hunts-grid" }
const _hoisted_90 = ["placeholder"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-hunts-help" }, [
  /*#__PURE__*/_createTextVNode("A gem finds a problem of its kind within the tolerance. Each player has "),
  /*#__PURE__*/_createElementVNode("b", null, "Gems per player"),
  /*#__PURE__*/_createTextVNode(" gems, one run: their Hunt ends when they find them all or the gems run out. Left empty: the problems and half again (at least 2 spare), so 30 for 20 problems.")
], -1 /* HOISTED */))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-hunts-help" }, [
  /*#__PURE__*/_createElementVNode("b", null, "The medals:"),
  /*#__PURE__*/_createTextVNode(" for each, the problems to find and the most gems used. Every hunter who reaches a medal wins it, so several can win Gold. Left empty: Gold for all of them, using the problems and a third more in gems; Silver two thirds and Bronze one third, with no gem limit. The Speed award goes to the fastest to find them all, or, if nobody does, the fastest of those who found the most. Medals are revealed at the end.")
], -1 /* HOISTED */))
const _hoisted_93 = { class: "nge-hunts-grid" }
const _hoisted_94 = { class: "nge-hunts-tierword" }
const _hoisted_95 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_96 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_97 = ["disabled"]
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "5. The Achievements", -1 /* HOISTED */))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-hunts-help" }, "What each medal gives. Either an Achievement made for this Hunt, named for it, with the game's medal or a picture you add; or one of the special Achievements you made in the Special Badges tab.", -1 /* HOISTED */))
const _hoisted_100 = { class: "nge-hunts-prize-head" }
const _hoisted_101 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_102 = { value: "own" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "badge" }, "A special Achievement you made", -1 /* HOISTED */))
const _hoisted_104 = ["aria-label"]
const _hoisted_105 = ["aria-checked", "onClick"]
const _hoisted_106 = ["src", "alt"]
const _hoisted_107 = ["aria-checked", "title", "onClick"]
const _hoisted_108 = ["src", "alt"]
const _hoisted_109 = ["disabled", "onChange"]
const _hoisted_110 = {
  key: 1,
  class: "nge-hunts-row"
}
const _hoisted_111 = ["src"]
const _hoisted_112 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_113 = { value: "" }
const _hoisted_114 = ["value"]
const _hoisted_115 = {
  key: 2,
  class: "nge-hunts-muted nge-hunts-special-desc"
}
const _hoisted_116 = {
  key: 3,
  class: "nge-hunts-muted"
}
const _hoisted_117 = { class: "nge-hunts-prize" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-hunts-prize-head" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-hunts-medal" }, "Helpers"),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-hunts-muted" }, "Everyone whose suggestion was planted in this Hunt (Hunt builder), at the end.")
], -1 /* HOISTED */))
const _hoisted_119 = { class: "nge-hunts-row" }
const _hoisted_120 = ["src"]
const _hoisted_121 = { value: "" }
const _hoisted_122 = ["value"]
const _hoisted_123 = ["disabled"]
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "6. Notifications and their pictures", -1 /* HOISTED */))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-hunts-help" }, "Three notes go to every player at their times. Give each a picture, or share one: any picture added here, or used in another Hunt, can be picked again for any note.", -1 /* HOISTED */))
const _hoisted_126 = { class: "nge-hunts-note-head" }
const _hoisted_127 = { class: "nge-hunts-note-word" }
const _hoisted_128 = {
  key: 1,
  class: "nge-hunts-muted"
}
const _hoisted_129 = {
  key: 2,
  class: "nge-hunts-muted"
}
const _hoisted_130 = ["disabled", "onClick"]
const _hoisted_131 = ["aria-label"]
const _hoisted_132 = ["aria-checked", "onClick"]
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "hunt/gold-128.png",
  alt: "Hunt default"
}, null, -1 /* HOISTED */))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hunts-pic-tag" }, "Default", -1 /* HOISTED */))
const _hoisted_135 = [
  _hoisted_133,
  _hoisted_134
]
const _hoisted_136 = ["aria-checked", "title", "onClick"]
const _hoisted_137 = ["src", "alt"]
const _hoisted_138 = ["disabled", "onChange"]
const _hoisted_139 = ["onClick"]
const _hoisted_140 = { class: "nge-hunts-help" }
const _hoisted_141 = { class: "nge-hunts-actions" }
const _hoisted_142 = ["disabled"]
const _hoisted_143 = ["disabled"]
const _hoisted_144 = {
  key: 1,
  class: "nge-hunts-muted"
}
const _hoisted_145 = {
  key: 1,
  class: "nge-hunts-group"
}
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Try it yourself, or copy it", -1 /* HOISTED */))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-hunts-help" }, "Play this Hunt as players will, at any time, even as a draft. Only you see it. Your gems are scored against the real answer key and you see which mergers they found, but no answer is kept or awarded. You can also play a running Hunt for real, like anyone.", -1 /* HOISTED */))
const _hoisted_148 = { class: "nge-hunts-actions" }
const _hoisted_149 = ["disabled"]
const _hoisted_150 = ["disabled"]
const _hoisted_151 = {
  key: 0,
  class: "nge-hunts-muted"
}
const _hoisted_152 = {
  key: 1,
  class: "nge-hunts-muted"
}
const _hoisted_153 = {
  key: 2,
  class: "nge-hunts-group"
}
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Run it", -1 /* HOISTED */))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-hunts-help" }, "The notes go out on their own at their times. To move things along early:", -1 /* HOISTED */))
const _hoisted_156 = { class: "nge-hunts-actions" }
const _hoisted_157 = ["disabled"]
const _hoisted_158 = ["disabled"]
const _hoisted_159 = ["disabled"]
const _hoisted_160 = ["disabled"]
const _hoisted_161 = ["disabled"]
const _hoisted_162 = ["disabled"]
const _hoisted_163 = {
  key: 3,
  class: "nge-hunts-actions"
}
const _hoisted_164 = ["disabled"]
const _hoisted_165 = ["disabled"]
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "A place the key missed", -1 /* HOISTED */))
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-hunts-help" }, [
  /*#__PURE__*/_createTextVNode("A real merger or missing extension the key does not have: put the crosshair on it (or type x, y, z as the coordinate bar shows them), say which it is, and add it. For a wide face, give it a size: a gem anywhere in it counts, and at a place the key has already, that place is made bigger. (In the key layers themselves, an ellipsoid, line or box works the same way.) Everyone is judged again, and each hunter whose gem finds it gets "),
  /*#__PURE__*/_createElementVNode("b", null, "Laser Eyes"),
  /*#__PURE__*/_createTextVNode(". A hunter's own gem on it can also be counted below with "),
  /*#__PURE__*/_createElementVNode("b", null, "Count it"),
  /*#__PURE__*/_createTextVNode(".")
], -1 /* HOISTED */))
const _hoisted_168 = { class: "nge-hunts-addrow" }
const _hoisted_169 = { class: "nge-hunts-addrow" }
const _hoisted_170 = {
  class: "nge-hunts-addsize",
  title: "For a wide face or a long stretch: a gem anywhere within this ball counts. At a place the key has already, it makes that place this big."
}
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "cut" }, "Merger (Cut)", -1 /* HOISTED */))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "merge" }, "Missing extension (Extend)", -1 /* HOISTED */))
const _hoisted_173 = [
  _hoisted_171,
  _hoisted_172
]
const _hoisted_174 = ["disabled"]
const _hoisted_175 = {
  key: 5,
  class: "nge-hunts-group"
}
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-hunts-help" }, [
  /*#__PURE__*/_createTextVNode("Click a hunter to see their gems. A miss on a real error the key missed: "),
  /*#__PURE__*/_createElementVNode("b", null, "Count it"),
  /*#__PURE__*/_createTextVNode(" adds that spot to the key and judges everyone again. After the end, Give the awards again.")
], -1 /* HOISTED */))
const _hoisted_177 = { class: "nge-hunts-board" }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "#", -1 /* HOISTED */))
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Player", -1 /* HOISTED */))
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Found", -1 /* HOISTED */))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Gems", -1 /* HOISTED */))
const _hoisted_182 = ["onClick", "onKeydown"]
const _hoisted_183 = { key: 0 }
const _hoisted_184 = { colspan: "5" }
const _hoisted_185 = {
  key: 0,
  class: "nge-hunts-muted"
}
const _hoisted_186 = { class: "nge-hunts-gems" }
const _hoisted_187 = { class: "nge-hunts-gem-n" }
const _hoisted_188 = { class: "nge-hunts-muted" }
const _hoisted_189 = ["disabled", "onClick"]
const _hoisted_190 = ["disabled", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    ($setup.notInstalled)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createTextVNode("The Hunt is not set up on the server yet: run "),
          _hoisted_4,
          _createTextVNode(" in Supabase, then deploy the "),
          _hoisted_5,
          _createTextVNode(" function.")
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.error && !$setup.notInstalled)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          ref: "errEl",
          class: "nge-hunts-error",
          role: "alert"
        }, _toDisplayString($setup.error), 513 /* TEXT, NEED_PATCH */))
      : _createCommentVNode("v-if", true),
    ($setup.message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString($setup.message), 1 /* TEXT */),
          ($setup.savedTimes)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                ($setup.savedTimes.announce)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString($setup.whenIso($setup.savedTimes.announce)), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("li", null, [
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString($setup.whenIso($setup.savedTimes.start)), 1 /* TEXT */)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString($setup.whenIso($setup.savedTimes.end)), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ], 512 /* NEED_PATCH */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" The list "),
    (!$setup.editing)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createVNode($setup["HuntBuilderSection"], { onMake: $setup.makeFromBuilt }),
          _createElementVNode("button", {
            class: "nge-hunts-btn nge-hunts-btn--primary",
            onClick: $setup.startNew
          }, "New Hunt"),
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Loading…"))
            : (!$setup.list.length && !$setup.notInstalled)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, "No Hunts yet."))
              : _createCommentVNode("v-if", true),
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (h) => {
              return (_openBlock(), _createElementBlock("li", {
                key: h.id,
                onClick: $event => ($setup.open(h)),
                onKeydown: _withKeys($event => ($setup.open(h)), ["enter"]),
                tabindex: "0"
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["nge-hunts-chip", `nge-hunts-chip--${h.phase}`])
                }, _toDisplayString($setup.PHASE_WORD[h.phase] || h.phase), 3 /* TEXT, CLASS */),
                _createElementVNode("span", _hoisted_16, _toDisplayString(h.title), 1 /* TEXT */),
                (h.admins_only)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Admins only"))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("span", _hoisted_18, [
                  _createTextVNode(_toDisplayString(h.target_count) + " mergers · " + _toDisplayString(h.players) + " " + _toDisplayString(h.players === 1 ? 'player' : 'players'), 1 /* TEXT */),
                  (h.start_at)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" · " + _toDisplayString($setup.local(h.start_at)), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ])
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_15))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          _createCommentVNode(" One hunt "),
          _createElementVNode("button", {
            class: "nge-hunts-back",
            onClick: $setup.close
          }, "← All Hunts"),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", {
              class: _normalizeClass(["nge-hunts-chip", `nge-hunts-chip--${$setup.phase}`])
            }, _toDisplayString($setup.PHASE_WORD[$setup.phase] || $setup.phase), 3 /* TEXT, CLASS */),
            _createCommentVNode(" The title, changed right here (Ames 2026-10-23: \"let me edit here to adjust the title\"): the same as Title in 2. The words "),
            _createElementVNode("label", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.form.title) = $event)),
                class: "nge-hunts-title-input",
                maxlength: "80",
                placeholder: "New Hunt",
                "aria-label": "The Hunt's title"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.form.title]
              ]),
              _hoisted_21
            ])
          ]),
          _createCommentVNode(" Reported by hunters (Ames 2026-10-26): at the top, so a report during a Hunt is seen at once "),
          ($setup.reports.length)
            ? (_openBlock(), _createElementBlock("fieldset", {
                key: 0,
                class: "nge-hunts-group nge-hunts-reports",
                disabled: !!$setup.busy
              }, [
                _createElementVNode("legend", null, "Reported by hunters (" + _toDisplayString($setup.reports.length) + ")", 1 /* TEXT */),
                _hoisted_23,
                ($setup.reports.some((r) => r.report_id))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "nge-hunts-btn nge-hunts-btn--primary",
                      onClick: $setup.goThroughReports
                    }, "Go through them, oldest first"))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("ul", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reports, (r) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: r.report_id ? `r${r.report_id}` : r.user_id + r.drop_id,
                      class: "nge-hunts-gem--miss"
                    }, [
                      _createElementVNode("span", null, [
                        _createElementVNode("b", null, _toDisplayString(r.name), 1 /* TEXT */),
                        _createTextVNode(": " + _toDisplayString(r.k === 'merge' ? 'missing extension' : 'merger') + _toDisplayString(r.report_id ? '' : ' (their gem)'), 1 /* TEXT */)
                      ]),
                      _createElementVNode("span", _hoisted_25, _toDisplayString((r.at || []).slice(0, 3).map((v) => Math.round(v)).join(', ')), 1 /* TEXT */),
                      (r.note)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, "\"" + _toDisplayString(r.note) + "\"", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("button", {
                        class: "nge-hunts-btn nge-hunts-btn--small",
                        disabled: !r.at,
                        title: "Move the view there",
                        onClick: _withModifiers($event => ($setup.goToGem({ id: r.drop_id || '', at: r.at, hit: false, k: r.k })), ["stop"])
                      }, "Go there", 8 /* PROPS */, _hoisted_27),
                      (r.report_id)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "nge-hunts-btn nge-hunts-btn--small",
                            title: "A real problem the answers missed: add it to the key, judge everyone again, Laser Eyes for whoever sent it",
                            onClick: _withModifiers($event => ($setup.addFromReport(r)), ["stop"])
                          }, "Add to the answers", 8 /* PROPS */, _hoisted_28))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "nge-hunts-btn nge-hunts-btn--small",
                            title: "A real error the answers missed: add it to the key, judge everyone again, Laser Eyes",
                            onClick: _withModifiers($event => ($setup.countReport(r)), ["stop"])
                          }, "Count it", 8 /* PROPS */, _hoisted_29)),
                      _createElementVNode("button", {
                        class: "nge-hunts-btn nge-hunts-btn--small",
                        title: "Not a problem the answers missed: off the list",
                        onClick: _withModifiers($event => ($setup.dismissReport(r)), ["stop"])
                      }, "Dismiss", 8 /* PROPS */, _hoisted_30)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ], 8 /* PROPS */, _hoisted_22))
            : _createCommentVNode("v-if", true),
          _createElementVNode("fieldset", {
            class: "nge-hunts-group",
            disabled: !!$setup.busy
          }, [
            _hoisted_32,
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.form.link) = $event)),
                class: "nge-hunts-input",
                placeholder: "https://… #!…",
                "aria-label": "View link"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.form.link]
              ]),
              _createElementVNode("button", {
                class: "nge-hunts-btn",
                disabled: !$setup.form.link.trim(),
                onClick: $setup.openLink
              }, "Open the link", 8 /* PROPS */, _hoisted_35)
            ]),
            _createVNode($setup["HuntFromEdits"], {
              "tolerance-um": Number($setup.form.tolerance_um) || 3,
              onShown: $setup.fromEditsShown,
              onCheck: $setup.checkInViewer
            }, null, 8 /* PROPS */, ["tolerance-um"]),
            _createElementVNode("ul", _hoisted_36, [
              (!$setup.candidates.length)
                ? (_openBlock(), _createElementBlock("li", _hoisted_37, "No annotation layer with points on screen yet."))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.candidates, (c) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: c.name,
                  class: _normalizeClass({ 'nge-hunts-keylayer--on': $setup.keyPick[c.name]?.on })
                }, [
                  _createElementVNode("label", _hoisted_38, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": $event => (($setup.keyPick[c.name].on) = $event),
                      type: "checkbox"
                    }, null, 8 /* PROPS */, _hoisted_39), [
                      [_vModelCheckbox, $setup.keyPick[c.name].on]
                    ]),
                    _createTextVNode(" " + _toDisplayString(c.name) + " ", 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_40, "(" + _toDisplayString(c.points) + " " + _toDisplayString(c.points === 1 ? 'point' : 'points') + ")", 1 /* TEXT */)
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": $event => (($setup.keyPick[c.name].kind) = $event),
                    class: "nge-hunts-input nge-hunts-keylayer-kind",
                    "aria-label": `What the points in ${c.name} mark`,
                    disabled: !$setup.keyPick[c.name]?.on
                  }, _hoisted_45, 8 /* PROPS */, _hoisted_41), [
                    [_vModelSelect, $setup.keyPick[c.name].kind]
                  ])
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("button", {
                class: "nge-hunts-btn nge-hunts-btn--quiet",
                disabled: !$setup.picked.length,
                title: "Read the ticked layers from the screen again",
                onClick: _cache[2] || (_cache[2] = $event => {$setup.autoRead = true; $setup.scan(); $setup.useScreen()})
              }, "↻ Read again", 8 /* PROPS */, _hoisted_47)
            ]),
            (!$setup.isNew && !$setup.read && !$setup.editing.edge_count)
              ? (_openBlock(), _createElementBlock("p", _hoisted_48, [
                  _createTextVNode("No places where the cells run out of the data are saved yet (a copy keeps the key as it was). "),
                  _hoisted_49,
                  _createTextVNode(", let the cells load in 3D, and save: they are found then.")
                ]))
              : _createCommentVNode("v-if", true),
            (!$setup.isNew && !$setup.read && $setup.form.link)
              ? (_openBlock(), _createElementBlock("p", _hoisted_50, [
                  _createTextVNode("The saved key is in the link: "),
                  _hoisted_51,
                  _createTextVNode(" to see its places on screen as layers (Mergers, Extensions, edge), change them, and save.")
                ]))
              : _createCommentVNode("v-if", true),
            (!$setup.isNew && !$setup.read)
              ? (_openBlock(), _createElementBlock("p", _hoisted_52, [
                  _createTextVNode("Saved key: " + _toDisplayString($setup.editing.target_count) + " " + _toDisplayString($setup.editing.target_count === 1 ? 'place' : 'places'), 1 /* TEXT */),
                  ($setup.editing.edge_count)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(", " + _toDisplayString($setup.editing.edge_count) + " edge " + _toDisplayString($setup.editing.edge_count === 1 ? 'spot' : 'spots'), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  _createTextVNode(" on " + _toDisplayString($setup.editing.cells?.length || 0) + " " + _toDisplayString(($setup.editing.cells?.length || 0) === 1 ? 'cell' : 'cells') + ", " + _toDisplayString($setup.datasetName($setup.editing.dataset)) + ". Read again to replace it", 1 /* TEXT */),
                  ($setup.editing.players)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" (every answer is scored again)")
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  _createTextVNode(".")
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.cellRows.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['x', 'y', 'z'], (axis, k) => {
                      return _withDirectives(_createElementVNode("input", {
                        key: axis,
                        "onUpdate:modelValue": $event => (($setup.cellRows[0].soma[k]) = $event),
                        type: "number",
                        class: "nge-hunts-input nge-hunts-xyz",
                        placeholder: k === 0 ? 'x (or paste x, y, z)' : axis,
                        "aria-label": `Start ${axis}`,
                        onPaste: _cache[3] || (_cache[3] = $event => ($setup.pasteSoma(0, $event)))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_57), [
                        [
                          _vModelText,
                          $setup.cellRows[0].soma[k],
                          void 0,
                          { number: true }
                        ]
                      ])
                    }), 64 /* STABLE_FRAGMENT */)),
                    _createElementVNode("button", {
                      class: "nge-hunts-btn nge-hunts-btn--small",
                      title: "Fill in where the crosshair is now",
                      onClick: _cache[4] || (_cache[4] = $event => ($setup.useCrosshair(0)))
                    }, "Use the crosshair")
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.somaMissing)
              ? (_openBlock(), _createElementBlock("p", _hoisted_58, "No start yet: players would start where the link is centered."))
              : (!$setup.read && $setup.editing.start_on_answer)
                ? (_openBlock(), _createElementBlock("p", _hoisted_59, "The saved start is " + _toDisplayString($setup.editing.start_gap_um) + " µm from a merger or extension, close enough to give it away. Move the crosshair, use it, and save.", 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_31),
          _createElementVNode("fieldset", {
            class: "nge-hunts-group",
            disabled: !!$setup.busy
          }, [
            _hoisted_61,
            _createElementVNode("label", null, [
              _createTextVNode("Title "),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.form.title) = $event)),
                class: "nge-hunts-input",
                maxlength: "80",
                placeholder: "The Pinky Merger Hunt"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.form.title]
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _hoisted_63,
              _createElementVNode("span", _hoisted_64, [
                _createElementVNode("button", {
                  type: "button",
                  title: "Bold",
                  onClick: _cache[6] || (_cache[6] = $event => ($setup.wrapSelection($setup.desc, '**', 'bold')))
                }, _hoisted_66),
                _createElementVNode("button", {
                  type: "button",
                  title: "Bullets",
                  onClick: _cache[7] || (_cache[7] = $event => ($setup.prefixLines($setup.desc, '• ', 'A point')))
                }, "• Bullets"),
                _createElementVNode("button", {
                  type: "button",
                  title: "Numbers",
                  onClick: _cache[8] || (_cache[8] = $event => ($setup.prefixLines($setup.desc, i => `${i + 1}. `, 'A step')))
                }, "1. Numbers")
              ])
            ]),
            _withDirectives(_createElementVNode("textarea", {
              ref: "descEl",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.form.description) = $event)),
              class: "nge-hunts-input",
              rows: "4",
              maxlength: "1500",
              "aria-label": "Description",
              placeholder: "What players are looking for, and any hint. The Hunt box already shows how to play.",
              onPaste: _cache[10] || (_cache[10] = $event => ($setup.pasteFormatted($setup.desc, $event)))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelText, $setup.form.description]
            ]),
            ($setup.descPreview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                  _hoisted_68,
                  _createElementVNode("div", { innerHTML: $setup.descPreview }, null, 8 /* PROPS */, _hoisted_69)
                ]))
              : _createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_60),
          _createElementVNode("fieldset", {
            class: "nge-hunts-group",
            disabled: !!$setup.busy
          }, [
            _hoisted_71,
            _hoisted_72,
            _createElementVNode("label", _hoisted_73, [
              _createElementVNode("input", {
                checked: $setup.form.admins_only || $setup.ON_TEST_SITE,
                disabled: $setup.ON_TEST_SITE,
                type: "checkbox",
                onChange: $setup.setAdminsOnly
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_74),
              _createTextVNode(),
              _hoisted_75
            ]),
            (!$setup.form.admins_only && !$setup.ON_TEST_SITE)
              ? (_openBlock(), _createElementBlock("p", _hoisted_76, "Scheduled, the notes go to every player's bell and post in chat."))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("label", null, [
                _createElementVNode("span", _hoisted_78, [
                  _createTextVNode("Announce (ET) "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "nge-hunts-nowlink",
                    title: "Announce it this minute",
                    onClick: _cache[11] || (_cache[11] = _withModifiers($event => ($setup.setNow('announce')), ["prevent"]))
                  }, "Now")
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($setup.form.announce) = $event)),
                  type: "datetime-local",
                  class: "nge-hunts-input"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.announce]
                ]),
                _createElementVNode("span", _hoisted_79, _toDisplayString($setup.whenLine($setup.form.announce) || 'no announcement'), 1 /* TEXT */)
              ]),
              _createElementVNode("label", null, [
                _createElementVNode("span", _hoisted_80, [
                  _createTextVNode("Start (ET) "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "nge-hunts-nowlink",
                    title: "Start it this minute",
                    onClick: _cache[13] || (_cache[13] = _withModifiers($event => ($setup.setNow('start')), ["prevent"]))
                  }, "Now")
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($setup.form.start) = $event)),
                  type: "datetime-local",
                  class: "nge-hunts-input"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.start]
                ]),
                _createElementVNode("span", _hoisted_81, _toDisplayString($setup.whenLine($setup.form.start)), 1 /* TEXT */)
              ]),
              _createElementVNode("label", null, [
                _createTextVNode("End (ET) "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (($setup.form.end) = $event)),
                  type: "datetime-local",
                  class: "nge-hunts-input"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.end]
                ]),
                _createElementVNode("span", _hoisted_82, _toDisplayString($setup.whenLine($setup.form.end)), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("label", _hoisted_83, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($setup.form.show_answers) = $event)),
                type: "checkbox"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, $setup.form.show_answers]
              ]),
              _createTextVNode(),
              _hoisted_84
            ]),
            _createElementVNode("label", _hoisted_85, [
              _createTextVNode("Results in the top bar for "),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => (($setup.form.results_hours) = $event)),
                type: "number",
                min: "1",
                max: "168",
                class: "nge-hunts-input",
                placeholder: "24"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  $setup.form.results_hours,
                  void 0,
                  { number: true }
                ]
              ]),
              _createTextVNode(" hours after the end "),
              _hoisted_86
            ])
          ], 8 /* PROPS */, _hoisted_70),
          _createElementVNode("fieldset", {
            class: "nge-hunts-group",
            disabled: !!$setup.busy
          }, [
            _hoisted_88,
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("label", null, [
                _createTextVNode("Tolerance (µm) "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => (($setup.form.tolerance_um) = $event)),
                  type: "number",
                  min: "0.1",
                  max: "100",
                  step: "0.5",
                  class: "nge-hunts-input"
                }, null, 512 /* NEED_PATCH */), [
                  [
                    _vModelText,
                    $setup.form.tolerance_um,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("label", null, [
                _createTextVNode("Gems per player "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => (($setup.form.max_points) = $event)),
                  type: "number",
                  min: "1",
                  class: "nge-hunts-input",
                  placeholder: $setup.defaultsFor ? `auto: ${$setup.defaultsFor.points}` : 'auto'
                }, null, 8 /* PROPS */, _hoisted_90), [
                  [
                    _vModelText,
                    $setup.form.max_points,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]),
            _hoisted_91,
            _hoisted_92,
            _createElementVNode("div", _hoisted_93, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.TIERS, (t) => {
                return _createElementVNode("div", {
                  key: t,
                  class: "nge-hunts-tierbox"
                }, [
                  _createElementVNode("span", _hoisted_94, _toDisplayString($setup.TIER_WORD[t]), 1 /* TEXT */),
                  _createElementVNode("label", null, [
                    _createTextVNode("find at least "),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": $event => (($setup.form.tiers[t]) = $event),
                      type: "number",
                      min: "1",
                      class: "nge-hunts-input",
                      placeholder: $setup.defaultsFor ? `auto: ${$setup.defaultsFor[t]}` : 'auto'
                    }, null, 8 /* PROPS */, _hoisted_95), [
                      [
                        _vModelText,
                        $setup.form.tiers[t],
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode("using at most "),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": $event => (($setup.form.tierGems[t]) = $event),
                      type: "number",
                      min: "1",
                      class: "nge-hunts-input",
                      placeholder: t === 'gold' && $setup.defaultsFor ? `auto: ${$setup.defaultsFor.goldGems} gems` : 'any gems'
                    }, null, 8 /* PROPS */, _hoisted_96), [
                      [
                        _vModelText,
                        $setup.form.tierGems[t],
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ])
              }), 64 /* STABLE_FRAGMENT */))
            ])
          ], 8 /* PROPS */, _hoisted_87),
          _createElementVNode("fieldset", {
            class: "nge-hunts-group",
            disabled: !!$setup.busy
          }, [
            _hoisted_98,
            _hoisted_99,
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.TIERS, (t) => {
              return _createElementVNode("div", {
                key: t,
                class: "nge-hunts-prize"
              }, [
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["nge-hunts-medal", `nge-hunts-medal--${t}`])
                  }, _toDisplayString($setup.TIER_WORD[t]), 3 /* TEXT, CLASS */),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": $event => (($setup.form.prize[t].mode) = $event),
                    class: "nge-hunts-input nge-hunts-prize-mode",
                    "aria-label": `${$setup.TIER_WORD[t]} Achievement`
                  }, [
                    _createElementVNode("option", _hoisted_102, "Made for this Hunt: " + _toDisplayString(($setup.form.title || 'This Hunt') + ': ' + $setup.TIER_WORD[t]), 1 /* TEXT */),
                    _hoisted_103
                  ], 8 /* PROPS */, _hoisted_101), [
                    [_vModelSelect, $setup.form.prize[t].mode]
                  ])
                ]),
                ($setup.form.prize[t].mode === 'own')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "nge-hunts-pics",
                      role: "radiogroup",
                      "aria-label": `Picture for ${$setup.TIER_WORD[t]}`
                    }, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["nge-hunts-pic", { 'nge-hunts-pic--on': !$setup.form.prize[t].image }]),
                        role: "radio",
                        "aria-checked": !$setup.form.prize[t].image,
                        title: "The game's medal",
                        onClick: $event => ($setup.form.prize[t].image = null)
                      }, [
                        _createElementVNode("img", {
                          src: $setup.medalSrc(t),
                          alt: `The game's ${$setup.TIER_WORD[t]} medal`
                        }, null, 8 /* PROPS */, _hoisted_106)
                      ], 10 /* CLASS, PROPS */, _hoisted_105),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.prizeLibrary, (p, i) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: p.image_url,
                          class: _normalizeClass(["nge-hunts-pic", { 'nge-hunts-pic--on': $setup.form.prize[t].image?.image_url === p.image_url }]),
                          role: "radio",
                          "aria-checked": $setup.form.prize[t].image?.image_url === p.image_url,
                          title: `Picture ${i + 1}`,
                          onClick: $event => ($setup.form.prize[t].image = p)
                        }, [
                          _createElementVNode("img", {
                            src: p.thumbnail_url,
                            alt: `Picture ${i + 1}`,
                            loading: "lazy"
                          }, null, 8 /* PROPS */, _hoisted_108)
                        ], 10 /* CLASS, PROPS */, _hoisted_107))
                      }), 128 /* KEYED_FRAGMENT */)),
                      _createElementVNode("label", {
                        class: _normalizeClass(["nge-hunts-pic nge-hunts-pic--add", { 'nge-hunts-pic--busy': $setup.prizeUploading === t }])
                      }, [
                        _createTextVNode(_toDisplayString($setup.prizeUploading === t ? 'Adding…' : '+ Add') + " ", 1 /* TEXT */),
                        _createElementVNode("input", {
                          type: "file",
                          accept: "image/png,image/jpeg,image/webp,image/gif",
                          class: "nge-hunts-file",
                          disabled: !!$setup.prizeUploading,
                          onChange: $event => ($setup.addPrizePicture(t, $event))
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_109)
                      ], 2 /* CLASS */)
                    ], 8 /* PROPS */, _hoisted_104))
                  : (_openBlock(), _createElementBlock("div", _hoisted_110, [
                      ($setup.specialById($setup.form.prize[t].badge_id))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "nge-hunts-special-img",
                            src: $setup.specialById($setup.form.prize[t].badge_id).thumbnail_url || $setup.specialById($setup.form.prize[t].badge_id).image_url,
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_111))
                        : _createCommentVNode("v-if", true),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": $event => (($setup.form.prize[t].badge_id) = $event),
                        class: "nge-hunts-input",
                        "aria-label": `Special Achievement for ${$setup.TIER_WORD[t]}`
                      }, [
                        _createElementVNode("option", _hoisted_113, _toDisplayString($setup.specials.length ? 'Pick one…' : 'None made yet: make one in the Special Badges tab'), 1 /* TEXT */),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.specials, (b) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: b.id,
                            value: b.id
                          }, _toDisplayString(b.name), 9 /* TEXT, PROPS */, _hoisted_114))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 8 /* PROPS */, _hoisted_112), [
                        [_vModelSelect, $setup.form.prize[t].badge_id]
                      ])
                    ])),
                ($setup.form.prize[t].mode === 'badge' && $setup.specialById($setup.form.prize[t].badge_id)?.description)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_115, _toDisplayString($setup.specialById($setup.form.prize[t].badge_id).description), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.form.prize[t].mode === 'badge' && !$setup.form.prize[t].badge_id)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_116, "With none picked, " + _toDisplayString($setup.TIER_WORD[t]) + " gives the Achievement made for this Hunt.", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            }), 64 /* STABLE_FRAGMENT */)),
            _createCommentVNode(" The Hunt Builder's helpers (Ames 2026-10-27: a special Achievement per Hunt, she makes it): given at the end. "),
            _createElementVNode("div", _hoisted_117, [
              _hoisted_118,
              _createElementVNode("div", _hoisted_119, [
                _createElementVNode("img", {
                  class: "nge-hunts-special-img",
                  src: $setup.specialById($setup.form.makerBadge) ? ($setup.specialById($setup.form.makerBadge).thumbnail_url || $setup.specialById($setup.form.makerBadge).image_url) : 'hunt/maker-128.png',
                  alt: ""
                }, null, 8 /* PROPS */, _hoisted_120),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => (($setup.form.makerBadge) = $event)),
                  class: "nge-hunts-input",
                  "aria-label": "Special Achievement for the helpers"
                }, [
                  _createElementVNode("option", _hoisted_121, "Made for this Hunt: " + _toDisplayString(($setup.form.title || 'This Hunt') + ': Hunt Maker'), 1 /* TEXT */),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.specials, (b) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: b.id,
                      value: b.id
                    }, _toDisplayString(b.name), 9 /* TEXT, PROPS */, _hoisted_122))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, $setup.form.makerBadge]
                ])
              ])
            ])
          ], 8 /* PROPS */, _hoisted_97),
          _createElementVNode("fieldset", {
            class: "nge-hunts-group",
            disabled: !!$setup.busy
          }, [
            _hoisted_124,
            _hoisted_125,
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.NOTE_KINDS, (k) => {
              return _createElementVNode("div", {
                key: k,
                class: "nge-hunts-note"
              }, [
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("span", _hoisted_127, _toDisplayString($setup.NOTE_WORD[k]), 1 /* TEXT */),
                  ($setup.noteSaved(k))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass($setup.noteSaved(k)?.sent ? 'nge-hunts-sent' : 'nge-hunts-due')
                      }, _toDisplayString($setup.noteSaved(k)?.sent ? 'sent' : 'goes out') + " " + _toDisplayString($setup.local($setup.noteSaved(k)?.send_at)), 3 /* TEXT, CLASS */))
                    : (k === 'announce' && !$setup.form.announce)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_128, "no announce time, so no announcement"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_129, _toDisplayString($setup.noteWhen(k)), 1 /* TEXT */)),
                  _createElementVNode("button", {
                    class: "nge-hunts-btn nge-hunts-btn--quiet nge-hunts-btn--small",
                    disabled: !$setup.form.start || !$setup.form.end,
                    onClick: $event => ($setup.previewNote(k))
                  }, "Preview", 8 /* PROPS */, _hoisted_130)
                ]),
                _createElementVNode("div", {
                  class: "nge-hunts-pics",
                  role: "radiogroup",
                  "aria-label": `Picture for ${$setup.NOTE_WORD[k]}`
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["nge-hunts-pic nge-hunts-pic--none", { 'nge-hunts-pic--on': !$setup.form.images[k] }]),
                    role: "radio",
                    "aria-checked": !$setup.form.images[k],
                    title: "The Hunt's gold medal",
                    onClick: $event => ($setup.form.images[k] = null)
                  }, _hoisted_135, 10 /* CLASS, PROPS */, _hoisted_132),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.library, (p, i) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: p.image_url,
                      class: _normalizeClass(["nge-hunts-pic", { 'nge-hunts-pic--on': $setup.form.images[k]?.image_url === p.image_url }]),
                      role: "radio",
                      "aria-checked": $setup.form.images[k]?.image_url === p.image_url,
                      title: `Picture ${i + 1}`,
                      onClick: $event => ($setup.form.images[k] = p)
                    }, [
                      _createElementVNode("img", {
                        src: p.thumbnail_url,
                        alt: `Picture ${i + 1}`,
                        loading: "lazy"
                      }, null, 8 /* PROPS */, _hoisted_137)
                    ], 10 /* CLASS, PROPS */, _hoisted_136))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createElementVNode("label", {
                    class: _normalizeClass(["nge-hunts-pic nge-hunts-pic--add", { 'nge-hunts-pic--busy': $setup.uploading === k }])
                  }, [
                    _createTextVNode(_toDisplayString($setup.uploading === k ? 'Adding…' : '+ Add') + " ", 1 /* TEXT */),
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/png,image/jpeg,image/webp,image/gif",
                      class: "nge-hunts-file",
                      disabled: !!$setup.uploading,
                      onChange: $event => ($setup.addPicture(k, $event))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_138)
                  ], 2 /* CLASS */)
                ], 8 /* PROPS */, _hoisted_131),
                ($setup.form.images[k] && $setup.NOTE_KINDS.some(o => $setup.form.images[o]?.image_url !== $setup.form.images[k]?.image_url))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "nge-hunts-link",
                      onClick: $event => ($setup.sameForAll(k))
                    }, "Use this picture for all three", 8 /* PROPS */, _hoisted_139))
                  : _createCommentVNode("v-if", true)
              ])
            }), 64 /* STABLE_FRAGMENT */)),
            _createElementVNode("p", _hoisted_140, [
              _createTextVNode("PNG, JPEG, WebP or GIF, up to 3 MB. Players see the small version in the bell list and the full picture when they open the note."),
              ($setup.scheduled)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" A changed picture reaches a note even after it was sent.")
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ])
          ], 8 /* PROPS */, _hoisted_123),
          _createElementVNode("div", _hoisted_141, [
            (!$setup.scheduled)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "nge-hunts-btn",
                  disabled: !!$setup.busy || $setup.keyNeeded || !$setup.form.title.trim(),
                  onClick: _cache[21] || (_cache[21] = $event => ($setup.save('draft')))
                }, "Save draft", 8 /* PROPS */, _hoisted_142))
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              class: "nge-hunts-btn nge-hunts-btn--primary",
              disabled: !!$setup.busy || $setup.keyNeeded || !$setup.form.title.trim(),
              onClick: _cache[22] || (_cache[22] = $event => ($setup.save($setup.scheduled ? undefined : 'scheduled')))
            }, _toDisplayString($setup.busy === 'save' ? 'Saving…' : $setup.scheduled ? 'Save changes' : 'Schedule'), 9 /* TEXT, PROPS */, _hoisted_143),
            ($setup.keyNeeded)
              ? (_openBlock(), _createElementBlock("span", _hoisted_144, "Read the answer key first."))
              : _createCommentVNode("v-if", true)
          ]),
          (!$setup.isNew)
            ? (_openBlock(), _createElementBlock("fieldset", _hoisted_145, [
                _hoisted_146,
                _hoisted_147,
                _createElementVNode("div", _hoisted_148, [
                  _createElementVNode("button", {
                    class: "nge-hunts-btn",
                    disabled: !!$setup.busy || !$setup.canTry || !!$setup.read,
                    onClick: $setup.tryIt
                  }, "Try it yourself", 8 /* PROPS */, _hoisted_149),
                  _createElementVNode("button", {
                    class: "nge-hunts-btn nge-hunts-btn--quiet",
                    disabled: !!$setup.busy,
                    title: "A draft copy: the same key, view, cells, words and settings",
                    onClick: $setup.duplicate
                  }, _toDisplayString($setup.busy === 'dup' ? 'Copying…' : 'Duplicate'), 9 /* TEXT, PROPS */, _hoisted_150),
                  ($setup.read)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_151, "Save first: a test uses the saved key and view."))
                    : (!$setup.canTry)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_152, "Read the answer key and save first."))
                      : _createCommentVNode("v-if", true)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Notes and controls for a scheduled hunt "),
          ($setup.scheduled)
            ? (_openBlock(), _createElementBlock("fieldset", _hoisted_153, [
                _hoisted_154,
                _hoisted_155,
                _createElementVNode("div", _hoisted_156, [
                  ($setup.phase === 'announced')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-hunts-btn",
                        disabled: !!$setup.busy,
                        onClick: _cache[23] || (_cache[23] = $event => ($setup.asking = 'announce'))
                      }, "Announce now", 8 /* PROPS */, _hoisted_157))
                    : _createCommentVNode("v-if", true),
                  ($setup.phase === 'announced')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "nge-hunts-btn",
                        disabled: !!$setup.busy,
                        onClick: _cache[24] || (_cache[24] = $event => ($setup.asking = 'start'))
                      }, "Start now", 8 /* PROPS */, _hoisted_158))
                    : _createCommentVNode("v-if", true),
                  ($setup.phase === 'live')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "nge-hunts-btn",
                        disabled: !!$setup.busy,
                        onClick: _cache[25] || (_cache[25] = $event => ($setup.asking = 'end'))
                      }, "End now and give the awards", 8 /* PROPS */, _hoisted_159))
                    : _createCommentVNode("v-if", true),
                  ($setup.phase === 'ended')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "nge-hunts-btn",
                        disabled: !!$setup.busy,
                        onClick: _cache[26] || (_cache[26] = $event => ($setup.act('hunt.award')))
                      }, "Give the awards again", 8 /* PROPS */, _hoisted_160))
                    : _createCommentVNode("v-if", true),
                  ($setup.editing.players)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        class: "nge-hunts-btn nge-hunts-btn--quiet",
                        disabled: !!$setup.busy,
                        onClick: _cache[27] || (_cache[27] = $event => ($setup.act('hunt.rescore')))
                      }, "Score again", 8 /* PROPS */, _hoisted_161))
                    : _createCommentVNode("v-if", true),
                  ($setup.phase !== 'ended')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 5,
                        class: "nge-hunts-btn nge-hunts-btn--danger",
                        disabled: !!$setup.busy,
                        onClick: _cache[28] || (_cache[28] = $event => ($setup.asking = 'cancel'))
                      }, "Cancel the Hunt", 8 /* PROPS */, _hoisted_162))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            : (!$setup.isNew)
              ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                  _createElementVNode("button", {
                    class: "nge-hunts-btn nge-hunts-btn--danger",
                    disabled: !!$setup.busy,
                    onClick: _cache[29] || (_cache[29] = $event => ($setup.asking = 'delete'))
                  }, "Delete", 8 /* PROPS */, _hoisted_164)
                ]))
              : _createCommentVNode("v-if", true),
          _createCommentVNode(" A place the key missed, by its coordinates (Ames 2026-10-26) "),
          (!$setup.isNew && $setup.scheduled)
            ? (_openBlock(), _createElementBlock("fieldset", {
                key: 4,
                class: "nge-hunts-group nge-hunts-addplace",
                disabled: !!$setup.busy
              }, [
                _hoisted_166,
                _hoisted_167,
                _createElementVNode("div", _hoisted_168, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => (($setup.addAt.xyz) = $event)),
                    type: "text",
                    class: "nge-hunts-input nge-hunts-xyz",
                    placeholder: "x, y, z",
                    "aria-label": "x, y, z",
                    spellcheck: "false"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.addAt.xyz]
                  ]),
                  _createElementVNode("button", {
                    class: "nge-hunts-btn nge-hunts-btn--small",
                    title: "Fill in where the crosshair is now",
                    onClick: $setup.addFromCrosshair
                  }, "Use the crosshair")
                ]),
                _createElementVNode("div", _hoisted_169, [
                  _createElementVNode("label", _hoisted_170, [
                    _createTextVNode("Size "),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => (($setup.addAt.size) = $event)),
                      type: "number",
                      min: "0",
                      max: "200",
                      step: "0.5",
                      class: "nge-hunts-input",
                      placeholder: "a point"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        $setup.addAt.size,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createTextVNode(" µm across")
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => (($setup.addAt.kind) = $event)),
                    class: "nge-hunts-input",
                    "aria-label": "Which kind"
                  }, _hoisted_173, 512 /* NEED_PATCH */), [
                    [_vModelSelect, $setup.addAt.kind]
                  ]),
                  _createElementVNode("button", {
                    class: "nge-hunts-btn",
                    disabled: !!$setup.busy,
                    onClick: $setup.addPlace
                  }, _toDisplayString($setup.busy === 'add' ? 'Adding…' : 'Add to the key'), 9 /* TEXT, PROPS */, _hoisted_174)
                ])
              ], 8 /* PROPS */, _hoisted_165))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Results "),
          ($setup.board.length)
            ? (_openBlock(), _createElementBlock("fieldset", _hoisted_175, [
                _createElementVNode("legend", null, "Hunters (" + _toDisplayString($setup.board.length) + ")", 1 /* TEXT */),
                _hoisted_176,
                _createElementVNode("table", _hoisted_177, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_178,
                      _hoisted_179,
                      _hoisted_180,
                      _hoisted_181,
                      _createElementVNode("th", null, _toDisplayString($setup.phase === 'ended' ? 'Medal' : 'Medal so far'), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.board, (b) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: b.rank
                      }, [
                        _createElementVNode("tr", {
                          class: _normalizeClass(["nge-hunts-hunter", { 'nge-hunts-hunter--open': $setup.runOf?.user_id === b.user_id }]),
                          tabindex: "0",
                          onClick: $event => ($setup.showRun(b)),
                          onKeydown: _withKeys($event => ($setup.showRun(b)), ["enter"])
                        }, [
                          _createElementVNode("td", null, _toDisplayString(b.rank), 1 /* TEXT */),
                          _createElementVNode("td", null, _toDisplayString(b.name), 1 /* TEXT */),
                          _createElementVNode("td", null, _toDisplayString(b.found) + " / " + _toDisplayString($setup.editing.target_count), 1 /* TEXT */),
                          _createElementVNode("td", null, _toDisplayString(b.gems), 1 /* TEXT */),
                          _createElementVNode("td", null, _toDisplayString(b.tier ? $setup.TIER_WORD[b.tier] : ''), 1 /* TEXT */)
                        ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_182),
                        ($setup.runOf?.user_id === b.user_id)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_183, [
                              _createElementVNode("td", _hoisted_184, [
                                (!$setup.runOf.drops.length)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_185, "No gems yet."))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("ul", _hoisted_186, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.runOf.drops, (d, i) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: d.id,
                                      class: _normalizeClass(d.hit ? 'nge-hunts-gem--hit' : 'nge-hunts-gem--miss')
                                    }, [
                                      _createElementVNode("span", _hoisted_187, _toDisplayString(i + 1), 1 /* TEXT */),
                                      _createElementVNode("span", null, _toDisplayString(d.k === 'merge' ? 'Extend' : 'Cut') + " gem · " + _toDisplayString(d.hit ? 'found' : 'missed'), 1 /* TEXT */),
                                      _createElementVNode("span", _hoisted_188, _toDisplayString((d.at || []).slice(0, 3).map((v) => Math.round(v)).join(', ')), 1 /* TEXT */),
                                      _createElementVNode("button", {
                                        class: "nge-hunts-btn nge-hunts-btn--small",
                                        disabled: !d.at,
                                        title: "Move the view to this gem",
                                        onClick: _withModifiers($event => ($setup.goToGem(d)), ["stop"])
                                      }, "Go there", 8 /* PROPS */, _hoisted_189),
                                      (!d.hit)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "nge-hunts-btn nge-hunts-btn--small",
                                            disabled: !!$setup.busy,
                                            title: "A real error the key missed: add it to the key, and judge everyone again",
                                            onClick: _withModifiers($event => ($setup.countIt(b, d)), ["stop"])
                                          }, "Count it", 8 /* PROPS */, _hoisted_190))
                                        : _createCommentVNode("v-if", true)
                                    ], 2 /* CLASS */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.asking === 'announce')
            ? (_openBlock(), _createBlock($setup["ConfirmDialog"], {
                key: 6,
                title: "Announce the Hunt now?",
                text: "The announcement goes to every player now, instead of at its time.",
                yes: "Announce now",
                onYes: _cache[33] || (_cache[33] = $event => ($setup.act('hunt.now', { kind: 'announce' }))),
                onNo: _cache[34] || (_cache[34] = $event => ($setup.asking = ''))
              }))
            : _createCommentVNode("v-if", true),
          ($setup.asking === 'start')
            ? (_openBlock(), _createBlock($setup["ConfirmDialog"], {
                key: 7,
                title: "Start the Hunt now?",
                text: "It starts for every player now, and the start notification goes out.",
                yes: "Start now",
                onYes: _cache[35] || (_cache[35] = $event => ($setup.act('hunt.now', { kind: 'start' }))),
                onNo: _cache[36] || (_cache[36] = $event => ($setup.asking = ''))
              }))
            : _createCommentVNode("v-if", true),
          ($setup.asking === 'end')
            ? (_openBlock(), _createBlock($setup["ConfirmDialog"], {
                key: 8,
                title: "End the Hunt now?",
                text: "Answers stop now. The end notification goes out and the gold, silver and bronze Achievements are given.",
                yes: "End and award",
                onYes: _cache[37] || (_cache[37] = $event => ($setup.act('hunt.now', { kind: 'end' }))),
                onNo: _cache[38] || (_cache[38] = $event => ($setup.asking = ''))
              }))
            : _createCommentVNode("v-if", true),
          ($setup.asking === 'cancel')
            ? (_openBlock(), _createBlock($setup["ConfirmDialog"], {
                key: 9,
                title: "Cancel the Hunt?",
                text: "Players stop seeing it. Notifications not sent yet are taken back; any already sent stay.",
                yes: "Cancel the Hunt",
                onYes: _cache[39] || (_cache[39] = $event => ($setup.act('hunt.cancel'))),
                onNo: _cache[40] || (_cache[40] = $event => ($setup.asking = ''))
              }))
            : _createCommentVNode("v-if", true),
          ($setup.asking === 'delete')
            ? (_openBlock(), _createBlock($setup["ConfirmDialog"], {
                key: 10,
                title: "Delete this Hunt?",
                text: "The Hunt, its key and every answer are deleted for good.",
                yes: "Delete for good",
                onYes: _cache[41] || (_cache[41] = $event => ($setup.act('hunt.delete'))),
                onNo: _cache[42] || (_cache[42] = $event => ($setup.asking = ''))
              }))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}